import { AfterViewInit, Component, Input, OnInit } from '@angular/core';

declare var $: any;

@Component({
    selector: '[ellipsis]',
    template: '<p id="ellipsis-body">{{ellipsisText}}</p>',
})


export class EllipsisComponent implements OnInit, AfterViewInit {
    @Input() ellipsisText: any;
    @Input() ellipsisNumOfLine: Number;

    constructor() {
    }

    ngOnInit() {
    }

    ngAfterViewInit() {
        $('#ellipsis-body').ellipsis({
            row: this.ellipsisNumOfLine || 3,
            onlyFullWords: false
        });
    }
}



// WEBPACK FOOTER //
// /Users/dominik/Documents/projekty/guru-monarch-beach-resort/guru-monarch-beach-resort/src/app/shared/ellipsis/ellipsis.component.ts